import axios from 'axios'
import aes from "@/util/aes";
import rsa from "@/util/rsa";
import qs from 'qs';

const encrypAxios = axios.create({
  baseURL: 'api/', // 基础路径
  timeout: 30000,
  withCredentials: [function (data) {
    return data
  }] // 表示请求可以携带cookie
})

// 请求拦截器（在请求之前进行一些配置）
encrypAxios.interceptors.request.use(
  // 任何所有请求会经过这里
  // config 是当前请求相关的配置信息对象
  // config 是可以修改的
  function (config) {
    // const user = JSON.parse(window.sessionStorage.getItem('token'))
    // // 如果有登录用户信息，则统一设置 token
    // if (user) {
    //     config.headers.Authorization = `Bearer ${user}`
    // }
    //获取前端RSA公钥密码、AES的key，并放到window
    let genKeyPair = rsa.genKeyPair();
    window.jsPublicKey = genKeyPair.publicKey;
    window.jsPrivateKey = genKeyPair.privateKey;
    var javaPublicKey = sessionStorage.getItem("javaPublicKey");
    let aesKey = aes.genKey(32);
    let aesKeyRes = rsa.encrypt(aesKey, javaPublicKey);//加密前端aes
    let data = config.data;
    let dataRes = aes.encrypt(JSON.stringify(data), aesKey);
    let jsPrivateKey = window.jsPrivateKey;
    jsPrivateKey = jsPrivateKey.replace("-----BEGIN RSA PRIVATE KEY-----\n", "");
    jsPrivateKey = jsPrivateKey.replace("\n-----END RSA PRIVATE KEY-----", "");
    window.jsPrivateKey = jsPrivateKey;
    let jsPublicKey = window.jsPublicKey;
    jsPublicKey = jsPublicKey.replace("-----BEGIN PUBLIC KEY-----\n", "");
    jsPublicKey = jsPublicKey.replace("\n-----END PUBLIC KEY-----", "");
    window.jsPublicKey = jsPublicKey;
    let dataVo = {
      data: dataRes,
      aesKey: aesKeyRes,//后端RSA公钥加密后的AES的key
      publicKey: jsPublicKey//前端公钥,
    };
    config.data = qs.stringify(dataVo);

    let jwt = sessionStorage.getItem("userToken");
    // console.log(jwt)
    if (null != jwt && jwt != "") {
      config.headers['Authorization'] = "Bearer " + jwt;
    }
    return config
  },
  // 请求失败，会经过这里
  function (error) {
    return Promise.reject(error)
  }
)

//响应了拦截器（在响应之后对数据进行一些处理）
encrypAxios.interceptors.response.use(res => {
  let parse = res.data
  let bkAes = rsa.decrypt(parse.data.aesKey, window.jsPrivateKey);
  let result = aes.decrypt(parse.data.data, bkAes)
  res.data = JSON.parse(result)
  return res
})


// 导出请求方法
export default encrypAxios



// WEBPACK FOOTER //
// ./src/util/encryphttp.js